//-------------------------------------------------------------------------------------
//                             Copyright(c) 2024
//-------------------------------------------------------------------------------------
//  Abstract:
//		基于i18n的多国语言切换表-中文表
//-------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------>
const en_US = {
	
}

export default en_US